<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="预留入库" name="op">
			<div class="content-box">
				<edit-reserve-inbound type="pre"></edit-reserve-inbound>
			</div>
		</el-tab-pane>
		<el-tab-pane label="预留入库记录" name="his">
			<his v-if="activeName=='his'" :type="[21]"></his>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import EditReserveInbound from "@/views/Reserve/subs/EditReserveInbound.vue";
import His from "@/views/Reserve/subs/His.vue";

export default {
	mixins: [TabPage],
	components: {
		His,
		EditReserveInbound
	},
	data() {
		return {
			activeName: "op"
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
